<template>
  <MConfirmBtn
    :placement="placement"
    :ok-text="okText"
    :cancel-text="cancelText"
    :overlay-style="{ zIndex: 9999, ...(maxWidth ? { maxWidth } : {}) }"
    v-bind="$attrs"
    @hide="$emit('cancel')"
    @cancel="$emit('cancel')"
    @confirm="$emit('confirm')"
    v-on="listeners"
  >
    <template v-slot:title>
      {{ message }}
    </template>
    <slot name="trigger">
      <a
        href="javascript:;"
        :aria-label="ariaLabel || $t('delete')"
        class="text-secondary-red delete-button inline-flex"
        @click.stop="$emit('trigger')"
        @keydown.enter.stop="$emit('trigger')"
        v-on="listeners"
      >
        <slot>
          <MTooltip v-if="showTooltip">
            <template v-slot:trigger>
              <MButton
                v-if="!onlyIcon"
                variant="default"
                class="delete-icon-button rounded"
              >
                <MIcon :size="size" name="trash-alt" />
              </MButton>
              <MButton
                v-else
                variant="default"
                class="button-neutral-lighter rounded p-0"
              >
                <MIcon
                  :size="size"
                  name="trash-alt"
                  class="text-secondary-red p-1"
                />
              </MButton>
            </template>
            {{ $t('delete') }}
          </MTooltip>
          <MButton v-else variant="default" class="delete-icon-button rounded">
            <MIcon :size="size" name="trash-alt" />
          </MButton>
        </slot>
      </a>
    </slot>
  </MConfirmBtn>
</template>

<script>
import { PreferenceComputed } from '@state/modules/preference'
export default {
  name: 'FlotoDeleteBtn',
  props: {
    message: { type: String, required: true },
    okText: {
      type: String,
      default() {
        return this.$tc('yes')
      },
    },
    cancelText: {
      type: String,
      default() {
        return this.$tc('cancel')
      },
    },
    maxWidth: { type: String, default: undefined },
    placement: { type: String, required: false, default: 'bottomRight' },
    // eslint-disable-next-line
    showTooltip: { type: Boolean, default: true },
    ariaLabel: { type: String, default: undefined },
    // eslint-disable-next-line
    border: { type: Boolean, default: true },
    onlyIcon: { type: Boolean, default: false },
    size: { type: String, default: 'md' },
  },
  computed: {
    ...PreferenceComputed,
    listeners() {
      const { confirm, cancel, ...listeners } = this.$listeners
      return listeners
    },
  },
}
</script>
<style lang="less" scoped>
.text-secondary-red {
  color: var(--secondary-red);
}
</style>
